import { EventEmitter, Injectable, WritableSignal } from '@angular/core';
import { from, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LocalizationService {
  localized: Map<string, string> = new Map();

  setLocale(lang: string, s: WritableSignal<string>) {
    fetch(`/assets/l10n-${lang}.json`)
      .then(response => response.json())
      .then(data => {
        console.log("initializing localization " + lang);
        this.localized = data;
        s.set(lang);
      })
      .catch(error => {
        console.log("using default locale", error);
        s.set("en");
      });
  }

  public _(key: string): string {
    return this.localized[key] || key;
  }
}
